import React from 'react';
import { Link, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, Briefcase, Settings, LogOut, Home, Wrench } from 'lucide-react';
import { motion } from 'framer-motion';
import adminApi from '../../api/adminApi';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    adminApi.clearToken();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/projects', icon: Briefcase, label: 'Projects' },
    { path: '/admin/services', icon: Wrench, label: 'Services' },
    { path: '/admin/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Bar */}
      <div className="bg-black text-white px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-black uppercase">FilmCraft Admin</h1>
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-sm font-bold hover:text-gray-300">
            <Home size={18} />
            View Site
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-sm font-bold hover:text-gray-300"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-white border-r min-h-[calc(100vh-64px)] p-6">
          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg font-semibold transition-colors ${
                    isActive
                      ? 'bg-black text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <Icon size={20} />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;